import { tabClasses, TabProps } from '@mui/material';
import { type Theme } from '@mui/material/styles';

declare module '@mui/material/Tab' {}

export default function Tab(theme: Theme) {
  const rootStyles = (ownerState: TabProps) => {
    const iconPostionVertical =
      ownerState.iconPosition === 'top' || ownerState.iconPosition === 'bottom';

    const defaultStyle = {
      gap: iconPostionVertical ? 0 : 4,
      padding: 4,
      margin: 0,
      borderRadius: theme.spacing(0.5),
      opacity: 1,
      minWidth: 48,
      textTransform: 'capitalize',
      fontWeight: theme.typography.fontWeightSemiBold,
      color: theme.palette.grey[700],

      [`&:not(.${tabClasses.selected})`]: {
        color: theme.palette.text.secondary,
      },
      [`& > .${tabClasses.iconWrapper}`]: {
        marginRight: `0!important`,
        marginBottom: `0!important`,
        margin: 0,
      },
      [`&:not(.${tabClasses.selected}):hover`]: {
        backgroundColor: theme.palette.grey[50],
      },
    };

    const disabledState = {
      [`&.${tabClasses.disabled}`]: {
        color: theme.palette.grey[400],
        backgroundColor: 'transparent',
        [`& > .${tabClasses.iconWrapper}`]: {
          color: theme.palette.grey[400],
        },
      },
    };

    return { ...defaultStyle, ...disabledState };
  };

  return {
    MuiTab: {
      defaultProps: {
        disableRipple: true,
        iconPosition: 'start',
      },
      styleOverrides: {
        root: ({ ownerState }: { ownerState: TabProps }) =>
          rootStyles(ownerState),
      },
    },
  };
}
